export const WebTemplatesEnum = {
  Default: 3,
  Golf: 7,
  Tipps: 8,
  Blog: 9,
  Deluxe: 10,
  Map: 11,
  Anniversary: 12
};
